/* eslint-disable */

import { COMPONENT_TYPE } from '../../../../app/constants/component_type';

xplenty.service('accountsCampaignsSelectorDataAdapter', [
  'connectionsService',
  '$stateParams',
  'ConnectionItemsResource',
  function (connectionsService, $stateParams, ConnectionItemsResource) {
    const dataAdapter = {};

    dataAdapter.load = function (component, callback, accountsToPopulate, error) {
      const adaptedData = {
        available: [],
        errors: [],
      };

      let schemaRequestData;
      switch (component.componentType) {
        case COMPONENT_TYPE.BING_ADS_SOURCE_COMPONENT:
          var accountsParsed = false;

          var _selectedAccounts = {};
          var _accountsToPopulate = accountsToPopulate || [];
          if (!accountsParsed) {
            _selectedAccounts = parseSelectedBingAccountsFromComponent(component);
            for (const accountId in _selectedAccounts) {
              _accountsToPopulate.push(accountId);
            }
            accountsParsed = true;
          }

          this.loadBingAccounts(
            component,
            _accountsToPopulate,
            function (accounts) {
              _.each(accounts, function (account) {
                const adaptedAccount = adaptBingAccount(account);
                if (_selectedAccounts[adaptedAccount.id]) {
                  setAccountSelection(adaptedAccount, _selectedAccounts[adaptedAccount.id]);
                }

                adaptedData.available.push(adaptedAccount);
              });
              for (const accountId in _selectedAccounts) {
                const selectedAccount = _.find(adaptedData.available, { id: accountId });
                if (!selectedAccount && accountId !== '') adaptedData.errors.push(missingAccountError(accountId));
              }
              callback(adaptedData);
            },
            error,
          );

          break;

        case COMPONENT_TYPE.FACEBOOK_ADS_INSIGHTS_SOURCE_COMPONENT:
          schemaRequestData = {
            api_version: component.api_version,
          };

          if (component.connection.type) {
            ConnectionItemsResource.accounts(
              component.connection.type,
              component.connection.id,
              schemaRequestData,
            ).subscribe(
              function (ad_accounts) {
                const selectedAccounts = angular.copy(component.ad_accounts);
                if (selectedAccounts[0] === 'any') selectedAccounts.splice(0, 1);
                _.each(ad_accounts, function (account) {
                  const adaptedAccount = new AdaptedAccount(account.name, account.id);
                  const selectedIndex = selectedAccounts.indexOf(adaptedAccount.id);
                  if (selectedIndex > -1) {
                    adaptedAccount.selected = true;
                    selectedAccounts.splice(selectedIndex, 1);
                  }
                  adaptedData.available.push(adaptedAccount);
                });
                _.each(selectedAccounts, function (missingAccountId) {
                  adaptedData.errors.push(missingAccountError(missingAccountId));
                });
                callback(adaptedData);
              },
              function (res) {
                res.error && adaptedData.errors.push(res.error.error_message);
                callback(adaptedData);
              },
            );
          }

          break;

        case COMPONENT_TYPE.ADWORDS_SOURCE_COMPONENT:
          if (component.connection.type) {
            var connectionObject = connectionsService.connections[component.connection.type];
            ConnectionItemsResource.customers(component.connection.type, component.connection.id).subscribe(
              function (ad_accounts) {
                let selectedAccounts;
                if (component.customer_ids) selectedAccounts = component.customer_ids.replace(/-/g, '').split(',');
                else selectedAccounts = [];
                // if (selectedAccounts[0] === 'any') selectedAccounts.splice(0, 1);
                _.each(ad_accounts, function (account) {
                  const adaptedAccount = new AdaptedAccount(account.name, account.customer_id);
                  const selectedIndex = selectedAccounts.indexOf(adaptedAccount.id);
                  if (selectedIndex > -1) {
                    adaptedAccount.selected = true;
                    selectedAccounts.splice(selectedIndex, 1);
                  }
                  adaptedData.available.push(adaptedAccount);
                });
                _.each(selectedAccounts, function (missingAccountId) {
                  adaptedData.errors.push(missingAccountError(missingAccountId));
                });
                callback(adaptedData);
              },
              function (res) {
                res.error && adaptedData.errors.push(res.error.error_message);
                callback(adaptedData);
              },
            );
          }

          break;

        case COMPONENT_TYPE.ANALYTICS_SOURCE_COMPONENT:
          schemaRequestData = {
            api_version: component.api_version,
          };

          if (component.connection.type) {
            ConnectionItemsResource.accounts(
              component.connection.type,
              component.connection.id,
              schemaRequestData,
            ).subscribe(
              function (ad_accounts) {
                let selectedViews;
                if (component.profile_ids) selectedViews = component.profile_ids.split(',');
                else selectedViews = [];
                _.each(ad_accounts, function (account) {
                  const adaptedAccount = adaptAnalyticsAccount(account);
                  let allCampaignsSelected = adaptedAccount.campaigns && !!adaptedAccount.campaigns.length;
                  _.each(adaptedAccount.campaigns, function (campaign) {
                    let someViewsSelected;
                    let allViewsSelected = campaign.views && campaign.views.length;
                    _.each(campaign.views, function (view) {
                      const viewIndex = selectedViews.indexOf(view.id);
                      if (viewIndex > -1) {
                        view.selected = true;
                        someViewsSelected = true;
                        selectedViews.splice(viewIndex, 1);
                      } else {
                        allViewsSelected = false;
                      }
                      return view.selected;
                    });
                    if (allViewsSelected) {
                      campaign.selected = true;
                      return;
                    }
                    if (someViewsSelected) {
                      campaign.semiSelected = true;
                    }
                    allCampaignsSelected = false;
                  });
                  if (allCampaignsSelected) adaptedAccount.selected = true;
                  adaptedData.available.push(adaptedAccount);
                });
                _.each(selectedViews, function (missingViewId) {
                  adaptedData.errors.push(missingAccountError(missingViewId, 'Profile'));
                });
                callback(adaptedData);
              },
              function (res) {
                res.error && adaptedData.errors.push(res.error.error_message);
                callback(adaptedData);
              },
            );
          }
          break;
      }

      return adaptedData;
    };

    // saving selected items in component in required format
    dataAdapter.save = function (component, adaptedData) {
      switch (component.componentType) {
        case COMPONENT_TYPE.BING_ADS_SOURCE_COMPONENT:
          component.accounts_campaigns = '';
          for (var i = adaptedData.selected.length - 1; i >= 0; i--) {
            if (!adaptedData.selected[i].selected) {
              _.each(adaptedData.selected[i].campaigns, function (campaign) {
                component.accounts_campaigns += `${adaptedData.selected[i].id};${campaign.id},`;
              });
            } else {
              component.accounts_campaigns += `${adaptedData.selected[i].id},`;
            }
          }
          component.accounts_campaigns = component.accounts_campaigns.substring(
            0,
            component.accounts_campaigns.length - 1,
          );
          break;

        case COMPONENT_TYPE.FACEBOOK_ADS_INSIGHTS_SOURCE_COMPONENT:
          if (adaptedData.selected.length > 0) {
            component.ad_accounts = _.map(adaptedData.selected, function (account) {
              return account.id;
            });
          }

          break;

        case COMPONENT_TYPE.ADWORDS_SOURCE_COMPONENT:
          component.customer_ids = _.pluck(adaptedData.selected, 'id').join(',');

          break;

        case COMPONENT_TYPE.ANALYTICS_SOURCE_COMPONENT:
          var viewsIds = '';

          _.each(adaptedData.selected, function (account) {
            _.each(account.campaigns, function (campaign) {
              _.each(campaign.views, function (view) {
                viewsIds += `${view.id},`;
              });
            });
          });

          // remove trailing comma
          viewsIds = viewsIds.slice(0, -1);

          component.profile_ids = viewsIds;

          break;
      }
    };

    dataAdapter.clear = function (component) {
      switch (component.componentType) {
        case COMPONENT_TYPE.BING_ADS_SOURCE_COMPONENT:
          component.accounts_campaigns = '';
          break;
        case COMPONENT_TYPE.FACEBOOK_ADS_INSIGHTS_SOURCE_COMPONENT:
          component.ad_accounts = [];
          break;
        case COMPONENT_TYPE.ADWORDS_SOURCE_COMPONENT:
          component.customer_ids = '';
          break;
        case COMPONENT_TYPE.ANALYTICS_SOURCE_COMPONENT:
          component.profile_ids = '';
          break;
      }
    };

    var parseSelectedBingAccountsFromComponent = function (component) {
      const selectedAccountsObject = {};
      const selectedAccountsData = component.accounts_campaigns.split(',');
      _.each(selectedAccountsData, function (selectedAccount) {
        const accountValue = selectedAccount.split(';');
        if (accountValue.length === 2) {
          if (selectedAccountsObject[accountValue[0]]) {
            selectedAccountsObject[accountValue[0]].push(Number(accountValue[1]));
          } else {
            selectedAccountsObject[accountValue[0]] = [Number(accountValue[1])];
          }
        } else {
          selectedAccountsObject[accountValue[0]] = [];
        }
      });
      return selectedAccountsObject;
    };

    var setAccountSelection = function (account, selectedAccount) {
      account.loaded = true;
      account.collapsed = false;
      if (selectedAccount.length === 0) {
        account.selected = true;
        account.collapsed = true;
        _.each(account.campaigns, function (campaign) {
          campaign.selected = true;
        });
      } else {
        _.each(selectedAccount, function (campaignId) {
          const campaignIndex = _.findIndex(account.campaigns, { id: campaignId });
          account.campaigns[campaignIndex].selected = true;
        });
      }
    };

    dataAdapter.loadBingAccounts = function (component, accountsToPopulate, callback, error) {
      const schemaRequestData = {
        api_version: component.api_version,
      };

      if (accountsToPopulate.length > 0) {
        schemaRequestData['accounts[]'] = accountsToPopulate;
      }

      if (component.connection.type) {
        ConnectionItemsResource.accounts(
          component.connection.type,
          component.connection.id,
          schemaRequestData,
        ).subscribe(callback, error);
      }
    };

    dataAdapter.loadAccountCampaigns = function (component, account, callback) {
      const schemaRequestData = {
        api_version: component.api_version,
        'accounts[]': [account.id],
      };

      ConnectionItemsResource.accounts(component.connection.type, component.connection.id, schemaRequestData).subscribe(
        function (accounts) {
          const _account = _.find(accounts, { account_id: account.id });
          const campaigns = _.map(_account.campaigns, function (campaign) {
            return new AdaptedBingCampaign(campaign.campaign_name, campaign.campaign_id, campaign.campaign_status);
          });
          _.each(campaigns, function (campaign) {
            campaign.selected = account.selected;
          });
          callback(campaigns);
        },
      );
    };

    var AdaptedAccount = function (name, id, campaigns) {
      this.name = name;
      this.id = id;
      if (campaigns) this.campaigns = campaigns;
      this.selected = false;
      this.semiSelected = false;
      this.collapsed = true;
      this.loaded = false;
      this.loading = false;
    };

    var AdaptedBingCampaign = function (name, id, status) {
      this.name = name;
      this.id = id;
      this.status = status;
      this.selected = false;
    };

    var adaptBingAccount = function (account) {
      let adaptedAccount;
      const adaptedCampaigns = [];
      _.each(account.campaigns, function (campaign) {
        adaptedCampaigns.push(adaptBingCampaign(campaign));
      });
      adaptedAccount = new AdaptedAccount(account.account_name, account.account_id, adaptedCampaigns);
      return adaptedAccount;
    };

    var adaptBingCampaign = function (campaign) {
      return new AdaptedBingCampaign(campaign.campaign_name, campaign.campaign_id, campaign.campaign_status);
    };

    const AdaptedAnalyticsProperty = function (name, id, views) {
      this.name = name;
      this.id = id;
      this.views = views;
      this.selected = false;
      this.semiSelected = false;
      this.collapsed = true;
    };

    const adaptAnalyticsCampaign = function (property) {
      return new AdaptedAnalyticsProperty(property.name, property.id, property.views);
    };

    var adaptAnalyticsAccount = function (account) {
      let adaptedAccount;
      const adaptedProperties = [];
      _.each(account.properties, function (property) {
        adaptedProperties.push(adaptAnalyticsCampaign(property));
      });
      adaptedAccount = new AdaptedAccount(account.name, account.id, adaptedProperties);
      return adaptedAccount;
    };

    var missingAccountError = function (accountId, name) {
      return `${name || 'Account'} with id: '${accountId}' could not be accessed`;
    };

    return dataAdapter;
  },
]);
